import { render, staticRenderFns } from "./PopupExtension.vue?vue&type=template&id=415611e0"
import script from "./PopupExtension.vue?vue&type=script&lang=js"
export * from "./PopupExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports